var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3252 14.9992L19.2002 12.1242C19.5627 11.7617 19.5627 11.1617 19.2002 10.7992C18.8377 10.4367 18.2377 10.4367 17.8752 10.7992L15.0002 13.6742L12.1252 10.7992C11.7627 10.4367 11.1627 10.4367 10.8002 10.7992C10.4377 11.1617 10.4377 11.7617 10.8002 12.1242L13.6752 14.9992L10.8002 17.8742C10.4377 18.2367 10.4377 18.8367 10.8002 19.1992C10.9877 19.3867 11.2252 19.4742 11.4627 19.4742C11.7002 19.4742 11.9377 19.3867 12.1252 19.1992L15.0002 16.3242L17.8752 19.1992C18.0627 19.3867 18.3002 19.4742 18.5377 19.4742C18.7752 19.4742 19.0127 19.3867 19.2002 19.1992C19.5627 18.8367 19.5627 18.2367 19.2002 17.8742L16.3252 14.9992Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapClose);
export default __webpack_public_path__ + "static/media/map-close.64f61f7ccbe653d93ea31d0a50148477.svg";
export { ForwardRef as ReactComponent };